export default "__VITE_ASSET__73fe2530__$_?component__"